import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import { gridsNames} from '../../../enums/gridsNames';
import { jsxActions as headerSettingsActions} from '../../../actions/Header/headerSettingsActions.js';
import { jsxActions as readersAndAntennasViewActions} from '../../../actions/Administration/RfidSettingsPage/readersAndAntennasViewActions';
import { jsxActions as createReaderDialogActions} from '../../../actions/Administration/RfidSettingsPage/Dialogs/createReaderDialogActions';
import { jsxActions as rfidSettingsPageActions} from '../../../actions/Administration/RfidSettingsPage/rfidSettingsPageActions';
import ReadersAndAntennasView from '../../../components/Administration/RfidSettingsPage/ReadersAndAntennasView/readersAndAntennasView';
import { jsxActions as readersAndAntennasViewGridActions} from  '../../../actions/Administration/RfidSettingsPage/readersAndAntennasViewGridActions';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(readersAndAntennasViewActions, dispatch),
      header: bindActionCreators(headerSettingsActions, dispatch),
      readersAndAntennasViewGridActions: bindActionCreators(readersAndAntennasViewGridActions, dispatch),
      createReaderDialogActions : bindActionCreators(createReaderDialogActions, dispatch),
      rfidSettingsPageActions : bindActionCreators(rfidSettingsPageActions, dispatch)
    }
  }
}

let ReadersAndAntennasViewContainer = connect(
  (state) => {
    let gridData = state.grid.get(gridsNames.ADMINISTRATION_RFID_SETTINGS_READERS_AND_ANTENNAS);
    let grid = gridData ? gridData : null;
    return {
      sGrid:  grid,
      sHasRows: grid && grid.get('rows') ? grid.get('rows').size > 0 : false,
      sSelectedRowsData: grid ? grid.get('selectedRowsData') : List(),
      sData: state.administration.getIn(['rfidSettingsPage', 'readersAndAntennasViewData']),
      sCreateReaderDialogData: state.administration.getIn(['rfidSettingsPage', 'createReaderDialog'])
    };
  },

  mapDispatchToProps
)(ReadersAndAntennasView);

export default ReadersAndAntennasViewContainer;


